import React, { useState, useCallback, memo } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "react-scroll";
import { navLinks, profile, scrollConfig } from "../config/site";

const NavBar = () => {
  const [nav, setNav] = useState(false);

  const toggleNav = useCallback(() => {
    setNav((prev) => !prev);
  }, []);

  const closeNav = useCallback(() => {
    setNav(false);
  }, []);

  const navLinkClass =
    "uppercase cursor-pointer hover:scale-125 duration-200";

  return (
    <nav className="flex items-center justify-between w-full max-w-full overflow-x-clip text-white z-30 fixed bg-[rgb(0,0,0,0.7)] h-10 py-10 px-4 sm:px-6">
      <Link to="home" smooth={scrollConfig.smooth} duration={scrollConfig.duration}>
        <h1
          className="font-signature ml-2 sm:ml-4 text-4xl sm:text-5xl font-bold cursor-pointer hover:scale-110 duration-200"
          id="logo"
        >
          {profile.firstName}
        </h1>
      </Link>

      <ul className="hidden md:flex text-[#ffffffc7] mr-10">
        {navLinks.map(({ id, link, label }) => (
          <li className="mx-4" key={id}>
            <Link
              to={link}
              smooth={scrollConfig.smooth}
              duration={scrollConfig.duration}
              className={navLinkClass}
              spy
              offset={-80}
            >
              {label}
            </Link>
          </li>
        ))}
      </ul>

      <button
        type="button"
        onClick={toggleNav}
        className="md:hidden mr-2 cursor-pointer z-10 text-[#ffffffc7]"
        aria-label={nav ? "Close menu" : "Open menu"}
      >
        {nav ? <X size={30} /> : <Menu size={30} />}
      </button>

      {nav && (
        <ul className="flex md:hidden flex-col text-[#ffffffc7] bg-[rgb(4,8,17,0.7)] absolute py-2 items-center justify-center top-16 left-0 w-full">
          {navLinks.map(({ id, link, label }) => (
            <li className="my-2" key={id}>
              <Link
                to={link}
                smooth={scrollConfig.smooth}
                duration={scrollConfig.duration}
                className={navLinkClass}
                offset={-80}
                onClick={closeNav}
              >
                {label}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </nav>
  );
};

export default memo(NavBar);
